class CartRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    new IntersectionObserver(this.handleIntersection.bind(this)).observe(this);
  }

  handleIntersection(entries, observer) {
    if (!entries[0].isIntersecting) return;
    observer.unobserve(this);
    
    fetch(this.dataset.url)
      .then(response => response.text())
      .then(text => {
        
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('cart-recommendations');
        const recommendation_navigation = recommendations.querySelector(".mini-cart__navigation")?.innerHTML.trim();
        if (recommendations && recommendations.innerHTML.trim().length && recommendation_navigation.length )  {
          this.innerHTML = recommendations.innerHTML;
        }else{
          document.querySelector("#mini-cart cart-recommendations")?.remove();
        }
        /*******CART RECOMMENDATION SLIDER******/
        const cartRecommendationSlider = new Swiper(".cart-recommendation--slider",{
          slidesPerView: 1.2,
          freeMode: true,
          spaceBetween: 15,
          pagination: {
            el: ".swiper-pagination",
            type: "progressbar",
          },
        })
      })
      .catch(e => {
        console.error(e);
      });
  }
}
customElements.define('cart-recommendations', CartRecommendations);
